if (!customElements.get('product-form')) {
customElements.define(
'product-form',
class ProductForm extends HTMLElement {
constructor() {
super();

this.form = this.querySelector('form');
this.form.querySelector('[name=id]').disabled = false;
this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
this.submitButton = this.querySelector('[type="submit"]');

if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

this.hideErrors = this.dataset.hideErrors === 'true';
}

onSubmitHandler(evt) {
evt.preventDefault();
if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

this.handleErrorMessage();

this.submitButton.setAttribute('aria-disabled', true);
this.submitButton.classList.add('loading');
this.querySelector('.loading__spinner').classList.remove('hidden');

const config = fetchConfig('javascript');
config.headers['X-Requested-With'] = 'XMLHttpRequest';
delete config.headers['Content-Type'];

const formData = new FormData(this.form);
if (this.cart) {
formData.append(
'sections',
this.cart.getSectionsToRender().map((section) => section.id)
);
formData.append('sections_url', window.location.pathname);
this.cart.setActiveElement(document.activeElement);
}
config.body = formData;

fetch(`${routes.cart_add_url}`, config)
.then((response) => response.json())
.then((response) => {
if (response.status) {
publish(PUB_SUB_EVENTS.cartError, {
source: 'product-form',
productVariantId: formData.get('id'),
errors: response.errors || response.description,
message: response.message,
});
this.handleErrorMessage(response.description);

const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
if (!soldOutMessage) return;
this.submitButton.setAttribute('aria-disabled', true);
this.submitButton.querySelector('span').classList.add('hidden');
soldOutMessage.classList.remove('hidden');
this.error = true;
return;
} else if (!this.cart) {
window.location = window.routes.cart_url;
return;
}

if (!this.error)
publish(PUB_SUB_EVENTS.cartUpdate, {
source: 'product-form',
productVariantId: formData.get('id'),
cartData: response,
});
this.error = false;
const quickAddModal = this.closest('quick-add-modal');
if (quickAddModal) {
document.body.addEventListener(
'modalClosed',
() => {
setTimeout(() => {
this.cart.renderContents(response);
});
},
{ once: true }
);
quickAddModal.hide(true);
} else {
this.cart.renderContents(response);
}
})
.catch((e) => {
console.error(e);
})
.finally(() => {
this.submitButton.classList.remove('loading');
if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
if (!this.error) this.submitButton.removeAttribute('aria-disabled');
this.querySelector('.loading__spinner').classList.add('hidden');
});
}

handleErrorMessage(errorMessage = false) {
if (this.hideErrors) return;

this.errorMessageWrapper =
this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
if (!this.errorMessageWrapper) return;
this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

if (errorMessage) {
this.errorMessage.textContent = errorMessage;
}
}
}
);
}

/* Technically Stable preorder cart notice */
(() => {
return; // Preorder cart notice disabled 26 October 2026.
window.tsPreorderNoticeInstalled=true;
const pending=new Map(); let dialog, timer, trigger;
function remember(form){
if(!form?.classList.contains('showProductPreorder')) return;
const id=new FormData(form).get('id'); if(!id) return;
pending.set(String(id),{note:form.querySelector('.gPreorderBottomMessage')?.textContent.trim()||'',time:Date.now(),trigger:document.activeElement});
}
document.addEventListener('submit',e=>remember(e.target),true);
document.addEventListener('click',e=>{const button=e.target.closest('.gPreorderBtn'); if(button) remember(button.closest('form'));},true);
function build(){
const style=document.createElement('style');
style.textContent='#ts-preorder-notice{box-sizing:border-box;width:min(480px,calc(100% - 32px));max-height:calc(100dvh - 32px);overflow:auto;padding:28px;border:3px solid #191721;border-radius:18px;background:#fff8e5;color:#191721;box-shadow:6px 6px 0 #191721;font-family:inherit}#ts-preorder-notice::backdrop{background:rgba(12,22,42,.72)}#ts-preorder-notice h2{margin:12px 28px 16px 0;font-size:28px;line-height:1.2;color:#191721}#ts-preorder-notice p{font-size:16px;line-height:1.5;margin:14px 0}#ts-preorder-notice .ts-tag{display:inline-block;padding:5px 10px;border:2px solid #191721;border-radius:6px;background:#19c2ed;font-size:13px;font-weight:700}#ts-preorder-notice .ts-date{border-left:4px solid #159ad6;padding:8px 12px;background:#fff}#ts-preorder-notice .ts-actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:24px}#ts-preorder-notice .ts-actions>*{box-sizing:border-box;flex:1 1 160px;display:flex;justify-content:center;align-items:center;min-height:48px;padding:10px 14px;border:2px solid #191721;border-radius:8px;color:#191721;background:#fff8e5;font:inherit;font-size:16px;text-align:center;text-decoration:none;cursor:pointer}#ts-preorder-notice .ts-actions button{background:#19c2ed;box-shadow:2px 2px 0 #191721}#ts-preorder-notice .ts-close{position:absolute;top:8px;right:8px;width:44px;height:44px;border:0;background:transparent;color:#191721;font:28px sans-serif;cursor:pointer}#ts-preorder-notice :focus-visible{outline:3px solid #087cad;outline-offset:3px}';
document.head.append(style);
dialog=document.createElement('dialog');dialog.id='ts-preorder-notice';dialog.setAttribute('aria-labelledby','ts-preorder-title');dialog.setAttribute('aria-describedby','ts-preorder-description ts-preorder-date');
dialog.innerHTML='<button type="button" class="ts-close" aria-label="Close preorder notice">&times;</button><span class="ts-tag">ADDED TO YOUR CART</span><h2 id="ts-preorder-title">This is a pre-order item</h2><p id="ts-preorder-description">This item will ship when it becomes available.</p><p id="ts-preorder-date" class="ts-date"></p><div class="ts-actions"><button type="button" autofocus>OK I understand</button></div>';

dialog.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>dialog.close()));
dialog.addEventListener('close',()=>{const cartClose=document.querySelector('button[aria-label="Close cart"]');if(cartClose)cartClose.focus();else if(trigger?.isConnected)trigger.focus();});
document.body.append(dialog);
}
function added(data){
if(!data||data.status||data.errors)return;
for(const item of data.items||[data]){
const id=String(item.variant_id||item.id||'');const entry=pending.get(id);
if(!entry||Date.now()-entry.time>30000)continue;
pending.delete(id);clearTimeout(timer);
timer=setTimeout(()=>{if(!dialog)build();trigger=entry.trigger;const date=dialog.querySelector('.ts-date');date.textContent=entry.note;date.hidden=!entry.note;if(!dialog.open)dialog.showModal();dialog.querySelector('.ts-actions button').focus();},600);
}
}
function isAdd(url){try{const u=new URL(url,location.href);return u.origin===location.origin&&/\/cart\/add(?:\.js)?\/?$/.test(u.pathname);}catch(_){return false;}}
const originalFetch=window.fetch;
window.fetch=function(...args){const result=originalFetch.apply(this,args);if(isAdd(args[0] instanceof Request?args[0].url:args[0]))result.then(r=>{if(r.ok)r.clone().json().then(added).catch(()=>{});}).catch(()=>{});return result;};
const originalOpen=XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open=function(method,url,...rest){if(isAdd(url)&&String(method).toUpperCase()==='POST')this.addEventListener('load',()=>{if(this.status<200||this.status>=300)return;try{added(this.responseType==='json'?this.response:JSON.parse(this.responseText));}catch(_){}},{once:true});return originalOpen.call(this,method,url,...rest);};
})();
